import { Association, Team, TeamMember } from './generated.types';
export interface Possession {
  _id: string;
  type: 'superAdmin' | 'zone' | 'company' | 'association' | 'team' | 'teamMember' | 'buyer' | 'invitation';
  typeTitle: string;
  title1: string;
  title2?: string;
  associationId?: string;
  teamId?: string;
  zoneId?: string;
}

export interface ExtendedAssociation extends Association {
  teams: ExtendedTeam[];
}

export interface ExtendedTeam extends Team {
  teamMembers: TeamMember[];
}

export enum ApprovalAction {
  REJECT = 'REJECT',
  APPROVE = 'APPROVE',
  REGENERATE = 'REGENERATE',
}

export enum ManageMode {
  EDIT = 'EDIT',       // Redigera befintliga kuponger
  ADD = 'ADD',         // Skapa nya tomma kuponger
  GENERATE = 'GENERATE', // Generera kuponger med AI
}

export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  NONE = '',
}
